import React from "react";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  isAuthenticated: boolean;
  role: string | null;
  allowedRoles: string[];
  children: React.ReactNode; // ✅ fix here
}

export default function ProtectedRoute({
  isAuthenticated,
  role,
  allowedRoles,
  children,
}: ProtectedRouteProps) {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (role && !allowedRoles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>; // ✅ works with ReactNode now
}
